// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"8edb2ac3","84":"946062dc","95":"fdbb2540","360":"08a607f2","431":"64e216e8","496":"2bf7e6f8","566":"ab238ff5","741":"423a6019","933":"d025780f"}[chunkId] + ".chunk.js";
};